import capitaliseFirstLetter from '../../../utils/capitaliseFirstLetter';
import { isString, isUndefined } from '../../../utils/isDefined';
import { translate } from '../../../i18n/I18nProvider';

export function createValueLabel(key, translateLabel = false) {
  if (!isString(key)) {
    return key;
  }

  let label = key;

  if (translateLabel) {
    label = findTranslation(key);
  }

  const mappedLabel = key.split('_').join(' ');

  return capitaliseFirstLetter(translateLabel ? label : mappedLabel);
}

export function mapValue(value) {
  if (isUndefined(value)) {
    return void 0;
  }

  return `${value}`;
}

const findTranslation = key => {
  const translation = {
    number: translate('TABLE.NUMBER'),
    line: translate('LINE'),
    type: translate('TABLE.TYPE'),
    name: translate('NAME'),
    client: translate('CLIENT'),
    function: translate('FUNCTION'),
    email: translate('EMAIL'),
    connect_username: translate('CONNECT_USERNAME')
  };

  return translation[key.toLowerCase()] || key;
};
